/**
 * @flow
 * @relayHash 4a62148fe4dc5f71d7cc9d2549972b68
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ObtainJSONWebTokenInput = {|
  clientMutationId?: ?string
|};
export type ObtainJSONWebTokenMutationVariables = {|
  input: ObtainJSONWebTokenInput
|};
export type ObtainJSONWebTokenMutationResponse = {|
  +obtainJsonWebToken: ?{|
    +userType: ?string,
    +token: ?string,
    +refreshToken: ?string,
  |}
|};
export type ObtainJSONWebTokenMutation = {|
  variables: ObtainJSONWebTokenMutationVariables,
  response: ObtainJSONWebTokenMutationResponse,
|};
*/


/*
mutation ObtainJSONWebTokenMutation(
  $input: ObtainJSONWebTokenInput!
) {
  obtainJsonWebToken(input: $input) {
    userType
    token
    refreshToken
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ObtainJSONWebTokenInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "obtainJsonWebToken",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ObtainJSONWebTokenPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "userType",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "token",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "refreshToken",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ObtainJSONWebTokenMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ObtainJSONWebTokenMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "ObtainJSONWebTokenMutation",
    "id": null,
    "text": "mutation ObtainJSONWebTokenMutation(\n  $input: ObtainJSONWebTokenInput!\n) {\n  obtainJsonWebToken(input: $input) {\n    userType\n    token\n    refreshToken\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1a4536072e06b3b033d01eef87085332';
module.exports = node;
